/* eslint-disable no-undef */
export const setPageTitleToLs = (title) => {
  try {
    localStorage.setItem('__WKD_PAGE_TITLE__', title);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e.message);
  }
};

export const DEFAULT_PAGE_TITLE = 'Dashboard - Phoenix Ads';

export const pushState = (path, extra = {}, defaultTitle = DEFAULT_PAGE_TITLE) => {
  const title = extra.pageTitle || defaultTitle;
  document.title = `${title} - Phoenix Ads`;
  setPageTitleToLs(title);
  window.history.pushState(extra, title, path);
};

export async function loadBundle(bundle) {
  try {
    await __webpack_init_sharing__('default');
    const scopes = Object.keys(window.__federation_expose__);
    let scope;
    for (let index = 0; index < scopes.length; index++) {
      if (window.__federation_expose__[scopes[index]].indexOf(bundle) > -1) {
        scope = scopes[index];
        break;
      }
    }
    const container = window[scope]; // or get the container somewhere else
    if (!container) {
      return {
        default: () => null,
      };
    }
    await container.init(__webpack_share_scopes__.default);
    const factory = await window[scope].get(bundle);
    const Module = factory();

    return Module;
  } catch (err) {
    console.error(err);
  }
}
